import { ActionIcon, Button, Group, Modal, Text, Tooltip } from "@mantine/core";
import { useLanguage } from "../../stores/LanguageStore";
import { IconFolderMinus } from "@tabler/icons-react";
import { useMemo, useState } from "react";
import { notifications } from "@mantine/notifications";
import { useDisclosure } from "@mantine/hooks";
import { useFolderStore } from "../../stores/FolderStore";
import { useParams } from "react-router-dom";

const SelectionRemoveFolder = ({
  handleEdit,
  getEditFunction,
  title_bold,
  apiRef,
  onFinish,
  isButton,
  rows,
  ids,
  ...buttonProps
}) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const folders = useFolderStore((s) => s.folders);
  const { folderId } = useParams();

  const folder = useMemo(() => {
    return folders.find((x) => x.id === parseInt(folderId));
  }, [folderId, folders]);

  const main = () => {
    let requests = [];
    let data = ids || apiRef?.current?.getSelectedRows();

    data.forEach((id) => {
      requests.push(
        new Promise((resolve, reject) => {
          let current = rows?.find((x) => x.id === id);
          let editFunction = handleEdit || getEditFunction?.(current);

          editFunction({ id, folder_id: 0 }).then((res) => {
            onFinish?.();
            resolve();
          });
        }),
      );
    });

    setLoading(true);
    Promise.all(requests).finally(() => {
      if (apiRef) {
        apiRef.current.setRowSelectionModel([]);
      }
      onFinish?.(true);
      setLoading(false);
      close();
    });
  };

  return (
    <>
      <Button
        variant="light"
        color="red"
        disabled={ids.length === 0}
        onClick={open}
        leftSection={<IconFolderMinus size={18} />}
        justify="start"
        className="to-blue"
      >
        {lang.components.folder_remove.button_label}
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={
          <Text size="md" truncate="end">
            {lang.components.folder_remove.title} <b>{title_bold}</b>
          </Text>
        }
        zIndex={9999}
        centered
        styles={{
          content: {
            boxShadow: "red 0 0 6px",
            border: "1px solid #a00",
          },
          title: {
            maxWidth: "92%",
          },
        }}
      >
        <Text size="sm">
          {lang.components.folder_remove.dialog.text_multiple.replace("#", ids.length)}{" "}
          <b>{folder?.name || ""}</b> <br /> <br />
          <b> {lang.components.folder_remove.dialog.text2_multiple} </b>
        </Text>

        <Group justify="end" mt={"lg"}>
          <Button
            variant="subtle"
            onClick={(e) => {
              e.stopPropagation();
              close();
            }}
            disabled={loading}
            size="md"
          >
            {lang.components.folder_remove.dialog.cancel_button}
          </Button>
          <Button color="red" onClick={main} loading={loading} size="md">
            {lang.components.folder_remove.dialog.submit_button}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default SelectionRemoveFolder;
